import api from './api';
import { Order } from '../types/Product';

export const orderService = {
  async getMyOrders(page: number = 1, limit: number = 10): Promise<{
    orders: Order[];
    pagination: { page: number; limit: number; total: number; pages: number };
  }> {
    const response = await api.get(`/orders?page=${page}&limit=${limit}`);
    return response.data.data;
  },

  async getOrderById(id: string): Promise<Order> {
    const response = await api.get<{ success: boolean; data: Order }>(`/orders/${id}`);
    return response.data.data;
  },

  async getAllOrders(page: number = 1, limit: number = 10): Promise<{
    orders: Order[];
    pagination: { page: number; limit: number; total: number; pages: number };
  }> {
    const response = await api.get(`/admin/orders?page=${page}&limit=${limit}`);
    return response.data.data;
  }
};
